import React from "react";
import { Wizard } from "components";

export const Profile = () => (
  <div>
    <Wizard />
  </div>
);
